import React from 'react'

import { MainTitle, LinkText, TextContent } from '../../../Shared';

const Thesis = props => {
  return (
    <div>
      <MainTitle>Thesis</MainTitle>
      <TextContent>
      [T1] Mai Tấn Hà "Xây dựng hệ thống dự đoán tình trạng giao thông ở TP.HCM," Master's thesis, HCMC University of Technology - Vietnam National University, 2020.
      <LinkText target='_blank' path='https://drive.google.com/file/d/1jovXWr2Lf5BuPbB1EDzEUKqm3noVDhFd/view?usp=sharing'> Download here</LinkText>.
      </TextContent>

      <TextContent>
      [T2] Nguyễn Ngọc Nam "Xây dựng hệ thống dự đoán tình trạng giao thông ở TP.HCM," Master's thesis, HCMC University of Technology - Vietnam National University, 2018.
      <LinkText target='_blank' path='https://drive.google.com/file/d/120oH5phkGn5cO9Fr9TuV7QSEAsUUB6RA/view?usp=sharing'> Download here</LinkText>.
      </TextContent>

      <TextContent>
      [T3] Trần Quốc Khánh, and Dương Vọng, "Phát triển hệ thống cảnh báo tình trạng giao thông ở TP. HCM trên nền tảng Web," Graduation thesis, HCMC University of Technology - Vietnam National University, 2020.
      <LinkText target='_blank' path='https://drive.google.com/file/d/16Y65_exwuG0QrmCCeSyS2G8BVK6wnnhF/view?usp=sharing'> Download here</LinkText>.
      </TextContent>

      <TextContent>
      [T4] Nguyễn Vũ, and Vũ Tuấn Anh, "Ứng dụng trên điện thoại di động cảnh báo tình trạng giao thông dựa trên dữ liệu từ cộng đồng," Graduation thesis, HCMC University of Technology - Vietnam National University, 2019.
      <LinkText target='_blank' path='https://drive.google.com/file/d/1z_twAv_4RT4HbtmYLpRQpGv930rzN6cC/view?usp=sharing'> Download here</LinkText>.
      </TextContent>

      <TextContent>
      [T5] Lê Công Huy, and Hoàng Mẫn Tiến, "Xây dựng hệ thống dự đoán tình trạng giao thông ở TP.HCM," Graduation thesis, HCMC University of Technology - Vietnam National University, 2019.
      <LinkText target='_blank' path='https://drive.google.com/file/d/1ngIOD6Kn5yyDr-VI2K-dnFb02cgDhHUK/view?usp=sharing'> Download here</LinkText>.
      </TextContent>

      <TextContent>
      [T6] Võ Trường Sơn, and Đào Quốc Hoàng, "Xây dựng ứng dụng Web hỗ trợ hoạt động thu thập và xử lý thông tin giao thông của chương trình giao thông đô thị thuộc VOH," Graduation thesis, HCMC University of Technology - Vietnam National University, 2019.
      <LinkText target='_blank' path='https://drive.google.com/file/d/1jY27aWFgNJHMSTvIq3b5cdz0it6QVgzK/view?usp=sharing'> Download here</LinkText>.
      </TextContent>

      <TextContent>
      [T7] Nguyễn Tiến Thành, Lê Trung Hiếu, and Nguyễn Gia Huy, "Urban Traffic Condition Aware Routing Approaches," Graduation thesis, HCMC University of Technology - Vietnam National University, 2022.
      <LinkText target='_blank' path='https://drive.google.com/file/d/1aOn_JdySQRDu9PvtiyuNku3biI1-gJ2c/view?usp=sharing'> Download here</LinkText>.
      </TextContent>

      <TextContent>
      [T8] Bùi Minh Kiệt, Huỳnh Ngọc Nhật Quang, "Predict Urban traffic condition and Estimate travel time", Graduation thesis, HCMC University of Technology - Vietnam National University, 2022.
      <LinkText target='_blank' path='https://drive.google.com/file/d/19oEmuzaiA0Gsk_NedTDn0gtgNiSo4zL1/view?usp=sharing'> Download here</LinkText>
      </TextContent>
    </div>
  )
}

Thesis.propTypes = {

}

export default Thesis
